import IPageLimit from '../../models/IPageLimit';

export const initialState: IPageLimit= {
    pageLimitOptions: [10, 50, 100, 1000],
    pageLimit: 100,
    isPageLimitLoaded: false
};